<template>
  <div id="HomeApp">

    <home-layout />

    <section class="conteudo-home">
      <div class="container">
        <div class="slider-home">
          <h2 v-show="meusCursos && meusCursos.length > 0">Continuar assistindo</h2>

          <meus-cursos-home-carousel :cursos="meusCursos" ref="meusCursosCarousel" v-show="meusCursos && meusCursos.length > 0"/>
          <div class="novo-continuar text-center" v-if="meusCursos && !meusCursos.length">
            <p>Começando agora na plataforma? Comece a estudar!</p>
            <a @click="$router.push('/cursos')" href="javascript:void(0)" class="btn btn-secondary mt-3">Escolha um curso!</a>
          </div>
        </div>

        <jaleko-recomenda-carousel v-if="$empresaUtils.temAcesso($tipoAcesso.HOME_DISCIPLINAS.nome, $configEmpresa.rotasRestritasAcesso)" ref="carouselJalekoRecomenda"/>

        <cursos-home-carousel :cursos="cursos.novos" ref="cursosNovosCarousel" />

        <disciplinas-carousel v-if="$empresaUtils.temAcesso($tipoAcesso.HOME_DISCIPLINAS.nome, $configEmpresa.rotasRestritasAcesso)" />

        <categorias-carousel v-if="$empresaUtils.temAcesso($tipoAcesso.HOME_CATEGORIAS.nome, $configEmpresa.rotasRestritasAcesso)" />

      </div>
    </section>

    <info-cookie-toast/>

  </div>
</template>

<script>
import CursosAPI from '@/api/cursos-api'

import InfoCookieToast from '@/modules/Home/components/InfoCookieToast'
import CursosHomeCarousel from '@/modules/Home/components/CursosHomeCarousel'
import MeusCursosHomeCarousel from '@/modules/Home/components/MeusCursosHomeCarousel'
import LoginUtils from '@/core/utils/login-utils'
import CategoriasCarousel from '@/modules/Home/components/CategoriasCarousel'
import DisciplinasCarousel from '@/modules/Home/components/DisciplinasCarousel'
import HomeLayout from '@/modules/Home/components/HomeLayout'
import JalekoRecomendaCarousel from './components/JalekoRecomendaCarousel.vue'

export default {
  name: 'HomeApp',
  components: {
    DisciplinasCarousel,
    CategoriasCarousel,
    MeusCursosHomeCarousel,
    CursosHomeCarousel,
    InfoCookieToast,
    HomeLayout,
    JalekoRecomendaCarousel
  },
  data () {
    return {
      meusCursos: null,
      cursos: {
        novos: [],
        favoritos: [],
        indicados: []
      }
    }
  },

  mounted () {
    CursosAPI.listarContinuacaoMeusCursos().then(data => {
      if (data && data.length) {
        this.meusCursos = data.map(item => {
          return {
            nome: item.NomeCurso,
            imagem_capa: item.ImagemCurso.includes('/') ? item.ImagemCurso : `cursos-plataforma/${item.ImagemCurso}`,
            referencia: item.ReferenciaCurso,
            url: `/sala-de-aula/${item.ReferenciaCurso}/${item.ReferenciaModulo}/${item.ReferenciaLicao}/${item.ReferenciaTopico}`,
            progresso: item.progresso,
            dataExpiracao: item.dataExpiracao
          }
        })

        this.$refs.meusCursosCarousel.applyOwlCarousel()
      } else {
        this.meusCursos = []
      }
      if (this.$refs.carouselJalekoRecomenda) {
        this.$refs.carouselJalekoRecomenda.applyOwlCarousel()
      }
    })

    const planos = LoginUtils.getUsuario().planos
    if (planos && planos.length) {
      CursosAPI.listarCursosNovos(planos[0].idPlanoUsuario).then(data => {
        let cursos = data.cursos
        if (cursos) {
          this.cursos.novos = cursos.map(curso => {
            curso.imagem_capa = curso.imagem_capa.includes('/') ? curso.imagem_capa : `cursos-plataforma/${curso.imagem_capa}`
            return curso
          })
          if (this.$refs.cursosNovosCarousel) this.$refs.cursosNovosCarousel.applyOwlCarousel()
        }
      })
    }
    // TODO Comentado por enquanto, ainda nao temos favoritos ou indicados para os usuarios
    // CursosAPI.listarCursosFavoritos().then(data => {
    //   this.cursos.favoritos = data.cursos
    //   if (this.$refs.cursosFavoritosCarousel) this.$refs.cursosFavoritosCarousel.applyOwlCarousel()
    // })
    //
    // CursosAPI.listarCursosIndicados().then(data => {
    //   this.cursos.indicados = data.cursos
    //   if (this.$refs.cursosIndicadosCarousel) this.$refs.cursosIndicadosCarousel.applyOwlCarousel()
    // })
  }
}
</script>

<style>

</style>
